import { render, staticRenderFns } from "./PopUpTextGroup.vue?vue&type=template&id=10c3e668"
import script from "./PopUpTextGroup.vue?vue&type=script&lang=js"
export * from "./PopUpTextGroup.vue?vue&type=script&lang=js"
import style0 from "./PopUpTextGroup.vue?vue&type=style&index=0&id=10c3e668&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports